"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgeVerification = void 0;
var av_events_enum_1 = require("./enum/av-events.enum");
var flow_steps_enum_1 = require("./enum/flow-steps.enum");
var AVBle_1 = require("./helpers/AVBle");
var bleb_1 = require("./helpers/bleb");
var secureAV_1 = require("./secureAV");
var AgeVerification = /** @class */ (function () {
    function AgeVerification(options) {
        var _this = this;
        this.options = {
            debugMode: true,
            intervalMs: 500,
            maxDuration: 15000
        };
        this.flowStepsCompleted = {
            IDLE: false,
            CHALLANGE_REQ: false,
            CHALLANGE_RES: false,
            SIGNATURE_REQ: false,
            SIGNATURE_RES: false,
        };
        this.AVEventsEnum = {
            AV_DEBUG: av_events_enum_1.AVEventsEnum.AV_DEBUG,
            AV_FLOW: av_events_enum_1.AVEventsEnum.AV_FLOW,
        };
        this.FlowSteps = {
            STARTED: flow_steps_enum_1.FlowSteps.STARTED,
            STEP1: flow_steps_enum_1.FlowSteps.STEP1,
            STEP2: flow_steps_enum_1.FlowSteps.STEP2,
            STEP3: flow_steps_enum_1.FlowSteps.STEP3,
            STEP3B: flow_steps_enum_1.FlowSteps.STEP3B,
            STEP4: flow_steps_enum_1.FlowSteps.STEP4,
            SUCCESS: flow_steps_enum_1.FlowSteps.STEP4,
            ALREADY_UNLOCKED: flow_steps_enum_1.FlowSteps.ALREADY_UNLOCKED,
            FAILURE: flow_steps_enum_1.FlowSteps.FAILURE,
            STOPPED: flow_steps_enum_1.FlowSteps.STOPPED,
            TIMEOUT: flow_steps_enum_1.FlowSteps.TIMEOUT
        };
        this.receivedChallengeArray = null;
        this.receivedSignatureArray = null;
        this.sendSignatureReqIntervalId = null;
        this.sendChallengeReqIntervalId = null;
        this.sendUnlockedAckIntervalId = null;
        this.challengeRes = null;
        this.selectedSignInterval = 500;
        this.chunksChallengeReq = AVBle_1.CHALLENGE_REQ_PAYLOAD;
        this.timer = 0;
        this.isRunning = false;
        this.generateRandomEven = function (max) {
            var random = Math.floor(Math.random() * max);
            return random % 2 === 0 ? random : random + 1;
        };
        /*==================*/
        /*      STEP 1      */
        /*==================*/
        this.sendChallengeReq = function () {
            _this.flowStepsCompleted.IDLE = true;
            _this.emitLog("[".concat(_this.getTime(), "] Sending Challenge request"), av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.STEP1);
            var incr = 0;
            _this.sendChallengeReqIntervalId = setInterval(function () {
                try {
                    (0, bleb_1.stopAdvertising)();
                    var seq = incr % (_this.chunksChallengeReq.length / 8); // Sequential packet counter
                    var num = _this.chunksChallengeReq.length / 8; // Total number of packets to receive
                    incr++;
                    var d = new AVBle_1.AVBleHelper().fromValues(_this.channel_challenge_request, seq, num, _this.chunksChallengeReq);
                    _this.emitLog("[sendChallengeReq] data to send " + d.getRaw());
                    _this.emitLog("[sendChallengeReq] channel " + d.getChannel());
                    _this.emitLog("[sendChallengeReq] seq " + d.getSeq());
                    _this.emitLog("[sendChallengeReq] num " + d.getNum());
                    _this.emitLog("[sendChallengeReq] data " + d.getData());
                    _this.emitLog("[sendChallengeReq] uuid " + d.toUUID());
                    _this.emitLog("[sendChallengeReq] uuid is valid? " + d.isValid());
                    (0, bleb_1.startAdvertising)(d.toUUID());
                    // console.log("dataToShow: ", d.toUUID());
                    _this.checkTimer();
                }
                catch (error) {
                    if (error instanceof Error) {
                        error = error.message;
                    }
                    _this.emitLog({ error: error, message: 'Challenge request error' }, av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.FAILURE);
                    _this.stopAV();
                }
            }, _this.options.intervalMs);
        };
        /*==================*/
        /*      STEP 3      */
        /*==================*/
        this.manageChallenge = function (challenge) { return __awaiter(_this, void 0, void 0, function () {
            var request, _a, setChallengeRes, setChallengeError, signature;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        /* Stop sending of challenge request */
                        this.emitLog('[_manageChallenge] Stop challenge sending: ' + this.sendChallengeReqIntervalId);
                        if (Number.isInteger(this.sendChallengeReqIntervalId)) {
                            clearInterval(this.sendChallengeReqIntervalId);
                            this.sendChallengeReqIntervalId = null;
                        }
                        request = {
                            challenge: challenge,
                            pathURL: this.options.secureAVUrl,
                            customer: this.options.customer,
                        };
                        this.emitLog("[".concat(this.getTime(), "] Invoking the IoT platform"), av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.STEP3);
                        return [4 /*yield*/, (0, secureAV_1.secureAV)(request)];
                    case 1:
                        _a = _b.sent(), setChallengeRes = _a[0], setChallengeError = _a[1];
                        if (setChallengeError !== null) {
                            this.emitLog("[".concat(this.getTime(), "] Something wen wrong with IoT paltform"), av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.FAILURE);
                            // alert('Something went wrong with the challenge');
                            (0, bleb_1.stopAdvertising)();
                            return [2 /*return*/];
                        }
                        signature = setChallengeRes.data.signature;
                        this.emitLog("[".concat(this.getTime(), "] signature received by server"), av_events_enum_1.AVEventsEnum.AV_FLOW);
                        this.emitLog('[_manageChallenge] signature received by server: ' + signature);
                        this.flowStepsCompleted.CHALLANGE_RES = true;
                        this.emitLog("[".concat(this.getTime(), "] Signature received from IoT: ") + signature, av_events_enum_1.AVEventsEnum.AV_FLOW);
                        this.manageSignatureReq(signature);
                        return [2 /*return*/];
                }
            });
        }); };
        /*=========================*/
        /*          STEP 3B        */
        /* Device already unlocked */
        /*=========================*/
        this.manageUnlockAck = function () { return __awaiter(_this, void 0, void 0, function () {
            var incr, timesRun, chunksUnlockedAck;
            var _this = this;
            return __generator(this, function (_a) {
                /* Stop submitting challenge request */
                this.emitLog('[_manageUnlockAck] Stop challenge sending: ' + this.sendChallengeReqIntervalId);
                if (Number.isInteger(this.sendChallengeReqIntervalId)) {
                    clearInterval(this.sendChallengeReqIntervalId);
                    this.sendChallengeReqIntervalId = null;
                }
                this.emitLog("[".concat(this.getTime(), "] Sending unlock ACK to device"), av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.STEP3B);
                incr = 0;
                timesRun = 0;
                chunksUnlockedAck = AVBle_1.UNLOCK_ACK;
                this.sendUnlockedAckIntervalId = setInterval(function () {
                    try {
                        (0, bleb_1.stopAdvertising)();
                        var seq = incr % (chunksUnlockedAck.length / 8); // Sequential packet counter
                        var num = chunksUnlockedAck.length / 8; // Total number of packets to receive
                        incr++;
                        var d = new AVBle_1.AVBleHelper().fromValues(_this.channel_signature_request, seq, num, chunksUnlockedAck);
                        (0, bleb_1.startAdvertising)(d.toUUID());
                        timesRun += 1;
                        if (timesRun === 8) {
                            clearInterval(_this.sendUnlockedAckIntervalId);
                            _this.emitLog('Already unlocked!', av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.ALREADY_UNLOCKED);
                            (0, bleb_1.stopAdvertising)();
                        }
                    }
                    catch (error) {
                        _this.emitLog({ error: error, message: 'send unlocked ack error' }, av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.FAILURE);
                        _this.stopAV();
                    }
                }, this.options.intervalMs);
                return [2 /*return*/];
            });
        }); };
        this.setOptions(options);
    }
    AgeVerification.prototype.setOptions = function (options) {
        if (!!options) {
            if (options.debugMode != null) {
                this.options.debugMode = options.debugMode;
            }
            if (options.secureAVUrl != null) {
                this.options.secureAVUrl = options.secureAVUrl;
            }
            if (options.intervalMs != null) {
                this.options.intervalMs = options.intervalMs;
            }
            if (options.customer != null) {
                this.options.customer = options.customer;
            }
        }
    };
    AgeVerification.prototype.setChallengeRes = function (challengeRes) {
        this.challengeRes = challengeRes;
    };
    AgeVerification.prototype.getTime = function () {
        var today = new Date();
        return (today.getHours() +
            ':' +
            today.getMinutes() +
            ':' +
            today.getSeconds() +
            '.' +
            today.getMilliseconds());
    };
    AgeVerification.prototype.createEvent = function (type, detail) {
        if (detail === void 0) { detail = {}; }
        return new CustomEvent(type, {
            detail: detail,
            bubbles: true,
            cancelable: true,
            composed: false,
        });
    };
    AgeVerification.prototype.dispatchEvent = function (eventType, detail) {
        var event = this.createEvent(eventType, detail);
        document.dispatchEvent(event);
    };
    AgeVerification.prototype.emitLog = function (message, eventType, flowStep) {
        if (eventType === void 0) { eventType = av_events_enum_1.AVEventsEnum.AV_DEBUG; }
        this.log(message);
        if (typeof message === 'string') {
            message = { message: message };
        }
        if (eventType === av_events_enum_1.AVEventsEnum.AV_FLOW && flowStep) {
            message.step = flowStep;
        }
        this.dispatchEvent(eventType, message);
    };
    AgeVerification.prototype.initFlow = function () {
        // channel number from smartphone will be even, from ePod odd
        var random_even = this.generateRandomEven(65525) + 2;
        this.channel_challenge_request = random_even; // random 1 - 65532
        this.channel_challenge_response = this.channel_challenge_request + 1;
        this.channel_signature_request = this.channel_challenge_response + 1;
        this.channel_signature_response = this.channel_signature_request + 1;
        this.receivedChallengeArray = null;
        this.receivedSignatureArray = null;
        this.sendSignatureReqIntervalId = null;
        this.sendChallengeReqIntervalId = null;
        this.sendUnlockedAckIntervalId = null;
        this.flowStepsCompleted.IDLE = false;
        this.flowStepsCompleted.CHALLANGE_REQ = false;
        this.flowStepsCompleted.CHALLANGE_RES = false;
        this.flowStepsCompleted.SIGNATURE_REQ = false;
        this.flowStepsCompleted.SIGNATURE_RES = false;
        this.timer = 0;
    };
    AgeVerification.prototype.startAV = function () {
        // interrupt if it already running
        if (this.isRunning) {
            return;
        }
        this.initFlow();
        this.isRunning = true;
        this.emitLog("[".concat(this.getTime(), "] AV start"), av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.STARTED);
        // Start listening ePod3 advertises
        this.startScanning();
        // Start submitting challenge request
        this.sendChallengeReq();
    };
    AgeVerification.prototype.stopAV = function () {
        [
            this.sendSignatureReqIntervalId,
            this.sendChallengeReqIntervalId,
            this.sendUnlockedAckIntervalId,
        ].forEach(function (id) {
            if (Number.isInteger(id)) {
                clearInterval(id);
            }
        });
        this.sendSignatureReqIntervalId = null;
        this.sendChallengeReqIntervalId = null;
        this.sendUnlockedAckIntervalId = null;
        try {
            (0, bleb_1.stopScanning)();
            (0, bleb_1.stopAdvertising)();
        }
        catch (_a) {
        }
        this.emitLog("[".concat(this.getTime(), "] AV stopped"), av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.STOPPED);
        this.isRunning = false;
    };
    AgeVerification.prototype.startScanning = function () {
        var _this = this;
        try {
            (0, bleb_1.startScanning)(function (scanResponse) {
                var _a;
                var manufacturerData = (_a = scanResponse.data) === null || _a === void 0 ? void 0 : _a.kCBAdvDataManufacturerData;
                if (!manufacturerData) {
                    return; // exit, all ePod3 advertises must have manufacturer data
                }
                var bytes = AVBle_1.AVBleHelper.uuidToBytes(manufacturerData.slice(4));
                var tp = new AVBle_1.AVBleHelper(Uint8Array.from(bytes));
                if (tp.isValid()) {
                    _this.emitLog('[onDiscoveryResult] Channel:' + tp.getChannel());
                    _this.emitLog('[onDiscoveryResult] Seq/Num:' + tp.getSeq() + '/' + tp.getNum());
                    _this.emitLog('[onDiscoveryResult] tp.getData(): ' + tp.getData());
                    _this.timer = 0; // reset timer
                    /*==================*/
                    /*      STEP 2      */
                    /*==================*/
                    // Check flow step
                    // If I receive packets from the challenge response channel, but I haven't completed the step yet...
                    if (tp.getChannel() === _this.channel_challenge_response &&
                        _this.flowStepsCompleted.CHALLANGE_REQ === false) {
                        /* if receivedChallengeArray is empty we reset it to an array of the length needed */
                        if (_this.receivedChallengeArray === null) {
                            _this.receivedChallengeArray = new Array(tp.getNum()).fill(null);
                            _this.emitLog("[onDiscoveryResult] Reset array receivedChallengeArray" +
                                _this.receivedChallengeArray.toString());
                        }
                        if (_this.receivedChallengeArray !== null) {
                            _this.emitLog('[onDiscoveryResult] Setting challenge seq:' + tp.getSeq());
                            _this.receivedChallengeArray[tp.getSeq()] = tp.getData();
                            var receivedChallengeArrayIsComplete = _this.receivedChallengeArray.every(function (element) { return element !== null; });
                            if (receivedChallengeArrayIsComplete) {
                                _this.emitLog('[onDiscoveryResult] Challenge complete: ' + _this.receivedChallengeArray.join(''), av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.STEP2);
                                _this.emitLog('[onDiscoveryResult] Challenge length: ' + _this.receivedChallengeArray.length);
                                // every value to hex string
                                var challengeString = '';
                                for (var i = 0; i < _this.receivedChallengeArray.length; i++) {
                                    for (var j = 0; j < _this.receivedChallengeArray[i].length; j++) {
                                        _this.log('[onDiscoveryResult] Challenge length chunk: ' +
                                            _this.receivedChallengeArray[i].length);
                                        challengeString += (_this.receivedChallengeArray[i][j] >>> 0)
                                            .toString(16)
                                            .padStart(2, '0')
                                            .substr(-2);
                                    }
                                }
                                _this.emitLog('[onDiscoveryResult] Challenge string: ' + challengeString);
                                _this.setChallengeRes(challengeString);
                                _this.flowStepsCompleted.CHALLANGE_REQ = true;
                                _this.log("[".concat(_this.getTime(), "] Received Challenge: ") + challengeString);
                                _this.log("[".concat(_this.getTime(), "] Challenge length: ") + challengeString.length);
                                _this.log("[".concat(_this.getTime(), "] selectedSignInterval: ") + _this.selectedSignInterval);
                                /* The epod is already unlocked */
                                if (challengeString === AVBle_1.CHALLENGE_RES_ALREADY_UNLOCKED.join('')) {
                                    _this.emitLog('[onDiscoveryResult] Device already unlocked!');
                                    _this.manageUnlockAck();
                                }
                                else {
                                    /* The epod is locked */
                                    _this.manageChallenge(challengeString);
                                }
                            }
                        }
                    }
                    /*==================*/
                    /*      STEP 4      */
                    /*==================*/
                    // Check flow step
                    // If I receive packets from the signature response channel, but I haven't completed the step yet...
                    else if (tp.getChannel() === _this.channel_signature_response &&
                        _this.flowStepsCompleted.SIGNATURE_REQ === false) {
                        /* if receivedSignatureArray is empty we reset it to an array of the length needed  */
                        if (_this.receivedSignatureArray === null) {
                            _this.receivedSignatureArray = new Array(tp.getNum()).fill(null);
                            _this.emitLog("[onDiscoveryResult] Resetto l'array receivedSignatureArray" +
                                _this.receivedSignatureArray.toString());
                        }
                        if (_this.receivedSignatureArray !== null) {
                            _this.emitLog('[onDiscoveryResult] Popolo il seq:' + tp.getSeq());
                            _this.receivedSignatureArray[tp.getSeq()] = tp.getData();
                            var receivedSignatureArrayIsComplete = _this.receivedSignatureArray.every(function (element) { return element !== null; });
                            if (receivedSignatureArrayIsComplete) {
                                _this.emitLog("[".concat(_this.getTime(), "] Signature response received: ") +
                                    _this.receivedSignatureArray.join(''), av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.STEP4);
                                _this.flowStepsCompleted.SIGNATURE_REQ = true;
                                var challengeString = '';
                                for (var i = 0; i < _this.receivedSignatureArray.length; i++) {
                                    for (var j = 0; j < _this.receivedSignatureArray[i].length; j++) {
                                        challengeString += _this.receivedSignatureArray[i][j];
                                    }
                                }
                                var differenceOk = challengeString === AVBle_1.SIGNATURE_RES_PAYLOAD_OK.join('');
                                var differenceKo = challengeString === AVBle_1.SIGNATURE_RES_PAYLOAD_KO.join('');
                                _this.stopAV();
                                if (differenceOk) {
                                    _this.emitLog("[".concat(_this.getTime(), "] Signature verification SUCCESS"), av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.SUCCESS);
                                }
                                else if (differenceKo) {
                                    _this.emitLog("[".concat(_this.getTime(), "] Signature verification FAILURE"), av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.FAILURE);
                                }
                                else {
                                    _this.emitLog("[".concat(_this.getTime(), "] Generic error on response after signature: ").concat(challengeString), av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.FAILURE);
                                }
                            }
                        }
                    }
                }
            });
        }
        catch (error) {
            this.emitLog({ error: error, message: 'scanning error' }, av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.FAILURE);
            this.stopAV();
        }
    };
    /*==================*/
    /*      STEP 3B     */
    /*==================*/
    AgeVerification.prototype.manageSignatureReq = function (signature) {
        var _this = this;
        // Prepare signature chunks
        var chunksSignReq = new AVBle_1.AVBleHelper().convertData(signature);
        this.emitLog("[".concat(this.getTime(), "] Start sending the signature"), av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.STEP3B);
        var incr = 0;
        this.sendSignatureReqIntervalId = setInterval(function () {
            try {
                (0, bleb_1.stopAdvertising)();
                _this.emitLog('[manageSignatureReq] selectedSignInterval: ' + _this.selectedSignInterval);
                var seq = incr % chunksSignReq.length; // Sequential packet counter
                var num = chunksSignReq.length; // Total number of packets to receive
                incr++;
                var d = new AVBle_1.AVBleHelper().fromValues(_this.channel_signature_request, seq, num, chunksSignReq[seq]);
                _this.emitLog('[manageSignatureReq] data to send ' + d.getRaw());
                _this.emitLog('[manageSignatureReq] channel ' + d.getChannel());
                _this.emitLog('[manageSignatureReq] seq ' + d.getSeq());
                _this.emitLog('[manageSignatureReq] num ' + d.getNum());
                _this.emitLog('[manageSignatureReq] data ' + d.getData());
                _this.emitLog('[manageSignatureReq] uuid ' + d.toUUID());
                _this.emitLog('[manageSignatureReq] uuid is valid? ' + d.isValid());
                (0, bleb_1.startAdvertising)(d.toUUID());
                _this.checkTimer();
            }
            catch (error) {
                _this.emitLog({ error: error, message: 'Signature error' }, av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.FAILURE);
                _this.stopAV();
            }
        }, this.options.intervalMs);
    };
    AgeVerification.prototype.log = function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            message[_i] = arguments[_i];
        }
        if (this.options.debugMode) {
            console.log.apply(console, message);
        }
    };
    AgeVerification.prototype.checkTimer = function () {
        this.timer += this.options.intervalMs;
        if (this.timer >= this.options.maxDuration) {
            this.emitLog("[".concat(this.getTime(), "] Timeout"), av_events_enum_1.AVEventsEnum.AV_FLOW, flow_steps_enum_1.FlowSteps.TIMEOUT);
            this.stopAV();
            var message = {
                intervals: [
                    this.sendSignatureReqIntervalId,
                    this.sendChallengeReqIntervalId,
                    this.sendUnlockedAckIntervalId
                ]
            };
            this.emitLog(message);
            return;
        }
    };
    return AgeVerification;
}());
exports.AgeVerification = AgeVerification;
